export function resizeTopLeftCorner(
  boundary,
  resizeOptions,
  absolutePoint,
) {
  const dx = absolutePoint.x - resizeOptions.startX
  const dy = absolutePoint.y - resizeOptions.startY

  const oldW = boundary.width + boundary.x
  const oldH = boundary.height + boundary.y

  if (boundary.x + dx >= 0) boundary.x += dx
  else boundary.x = 0

  if (boundary.width - dx <= resizeOptions.minWidth) {
    boundary.x -= resizeOptions.minWidth - (boundary.width - dx)
    boundary.width = resizeOptions.minWidth
  } else boundary.width -= dx

  if (boundary.y + dy >= 0) boundary.y += dy
  else boundary.y = 0

  if (boundary.height - dy <= resizeOptions.minHeight) {
    boundary.y -= resizeOptions.minHeight - (boundary.height - dy)
    boundary.height = resizeOptions.minHeight
  } else boundary.height -= dy

  if (boundary.width + boundary.x > oldW) boundary.width -= boundary.width + boundary.x - oldW

  if (boundary.y + boundary.height > oldH) boundary.height -= boundary.height + boundary.y - oldH

  resizeOptions.startX = absolutePoint.x
  resizeOptions.startY = absolutePoint.y

  //for square area
  if (!resizeOptions.square) return

  if (boundary.width > boundary.height) {
    boundary.y -= boundary.width - boundary.height
    boundary.height = boundary.width
  } else {
    boundary.x -= boundary.height - boundary.width
    boundary.width = boundary.height
  }

  if (boundary.x < 0) {
    boundary.width = boundary.height += boundary.x
    boundary.y -= boundary.x
    boundary.x = 0
  }

  if (boundary.y < 0) {
    boundary.width = boundary.height += boundary.y
    boundary.x -= boundary.y
    boundary.y = 0
  }
}

export function resizeTopRigthCorner(
  boundary,
  resizeOptions,
  absolutePoint,
  area,
) {
  const dx = absolutePoint.x - resizeOptions.startX
  const dy = absolutePoint.y - resizeOptions.startY

  const oldH = boundary.y + boundary.height

  if (boundary.y + dy >= 0) boundary.y += dy
  else boundary.y = 0

  if (boundary.height - dy <= resizeOptions.minHeight) {
    boundary.y -= resizeOptions.minHeight - (boundary.height - dy)
    boundary.height = resizeOptions.minHeight
  } else boundary.height -= dy

  if (boundary.width + dx <= resizeOptions.minWidth) boundary.width = resizeOptions.minWidth
  else boundary.width += dx

  if (boundary.x + boundary.width > area.width) boundary.width = area.width - boundary.x

  if (boundary.y + boundary.height > area.height) boundary.height = area.height - boundary.y

  if (boundary.y + boundary.height > oldH) boundary.height -= boundary.height + boundary.y - oldH

  resizeOptions.startX = absolutePoint.x
  resizeOptions.startY = absolutePoint.y

  //for square area
  if (!resizeOptions.square) return

  if (boundary.width > boundary.height) {
    boundary.y -= boundary.width - boundary.height
    boundary.height = boundary.width
  } else boundary.width = boundary.height

  if (boundary.y < 0) {
    boundary.width = boundary.height += boundary.y
    boundary.y = 0
  }

  if (boundary.x + boundary.width > area.width) {
    boundary.y += boundary.x + boundary.width - area.width
    boundary.width = boundary.height -= boundary.x + boundary.width - area.width
  }
}

export function resizeBottomLeftCorner(
  boundary,
  resizeOptions,
  absolutePoint,
  area,
) {
  const dx = absolutePoint.x - resizeOptions.startX
  const dy = absolutePoint.y - resizeOptions.startY

  const oldW = boundary.x + boundary.width

  if (boundary.x + dx >= 0) boundary.x += dx
  else boundary.x = 0

  if (boundary.width - dx <= resizeOptions.minWidth) {
    boundary.x -= resizeOptions.minWidth - (boundary.width - dx)
    boundary.width = resizeOptions.minWidth
  } else boundary.width -= dx

  if (boundary.height + dy <= resizeOptions.minHeight) boundary.height = resizeOptions.minHeight
  else boundary.height += dy

  if (boundary.y + boundary.height > area.height) boundary.height = area.height - boundary.y

  if (boundary.width + boundary.x > oldW) boundary.width -= boundary.width + boundary.x - oldW

  resizeOptions.startX = absolutePoint.x
  resizeOptions.startY = absolutePoint.y

  //for square area
  if (!resizeOptions.square) return

  if (boundary.width > boundary.height) boundary.height = boundary.width
  else {
    boundary.x -= boundary.height - boundary.width
    boundary.width = boundary.height
  }

  if (boundary.y + boundary.height > area.height) {
    boundary.x += boundary.y + boundary.height - area.height
    boundary.width = boundary.height -= boundary.y + boundary.height - area.height
  }

  if (boundary.x < 0) {
    boundary.width = boundary.height += boundary.x
    boundary.x = 0
  }
}

export function resizeBottomRightCorner(
  boundary,
  resizeOptions,
  absolutePoint,
  area,
) {
  const dx = absolutePoint.x - resizeOptions.startX
  const dy = absolutePoint.y - resizeOptions.startY

  if (boundary.width + dx < resizeOptions.minWidth) boundary.width = resizeOptions.minWidth
  else boundary.width += dx

  if (boundary.height + dy < resizeOptions.minHeight) boundary.height = resizeOptions.minHeight
  else boundary.height += dy

  if (boundary.x + boundary.width > area.width) boundary.width = area.width - boundary.x

  if (boundary.y + boundary.height > area.height) boundary.height = area.height - boundary.y

  resizeOptions.startX = absolutePoint.x
  resizeOptions.startY = absolutePoint.y

  //for square area
  if (!resizeOptions.square) return

  if (boundary.y + boundary.width > area.height) boundary.width = area.height - boundary.y

  if (boundary.x + boundary.height > area.width) boundary.height = area.width - boundary.x

  if (boundary.width > boundary.height) boundary.height = boundary.width
  else boundary.width = boundary.height
}

export function dragItemView(
  boundary,
  resizeOptions,
  absolutePoint,
  area,
) {
  const dx = absolutePoint.x - resizeOptions.startX
  const dy = absolutePoint.y - resizeOptions.startY

  boundary.x += dx
  boundary.y += dy

  if (boundary.x < 0) boundary.x = 0

  if (boundary.y < 0) boundary.y = 0

  if (boundary.x + boundary.width > area.width) boundary.x = area.width - boundary.width

  if (boundary.y + boundary.height > area.height) boundary.y = area.height - boundary.height

  resizeOptions.startX = absolutePoint.x
  resizeOptions.startY = absolutePoint.y
}



// WEBPACK FOOTER //
// ./src/drawing/core/mouseMove/utils.js